var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgI4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52.71 54.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-curriculo_selecionado") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.67,54.05c1.07-.08.55-.48,1.34-1.27,1.39-1.43,3.16-2.86,3.37-4.24L28.47,47l-.63,3.52c0,.56,0,1.61,0,2-.1.87-.59.58-.13,1.52Z",
    transform: "translate(0 0)",
    fill: "#4d4d4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.87,13.58A9.57,9.57,0,0,0,50,12.37a9.73,9.73,0,0,0-.09-1.22l2.61-2a.61.61,0,0,0,.15-.79L50.16,4a.63.63,0,0,0-.55-.31.71.71,0,0,0-.21,0L46.32,5A8.83,8.83,0,0,0,44.24,3.8L43.77.52A.61.61,0,0,0,43.16,0H38.21a.59.59,0,0,0-.6.52L37.14,3.8A9.42,9.42,0,0,0,35.05,5L32,3.77a.93.93,0,0,0-.22,0,.66.66,0,0,0-.54.31L28.74,8.32a.6.6,0,0,0,.15.79l2.61,2a9.87,9.87,0,0,0-.09,1.22,9.85,9.85,0,0,0,.09,1.21l-2.61,2a.61.61,0,0,0-.15.79l2.47,4.28a.64.64,0,0,0,.55.31A.71.71,0,0,0,32,21l3.08-1.24a8.73,8.73,0,0,0,2.09,1.22l.47,3.27a.59.59,0,0,0,.6.52h4.95a.59.59,0,0,0,.6-.52l.47-3.27a9.08,9.08,0,0,0,2.09-1.22L49.4,21a.93.93,0,0,0,.22,0,.63.63,0,0,0,.54-.31l2.47-4.28a.61.61,0,0,0-.15-.79l-2.61-2Zm-2.45-2.12a6.87,6.87,0,0,1,.07.9,8.76,8.76,0,0,1-.07.91l-.17,1.39,1.1.87,1.34,1-.87,1.5-1.57-.63L46,16.92l-1.12.84a7.57,7.57,0,0,1-1.54.9L42,19.19l-.2,1.4-.25,1.67H39.82l-.24-1.67-.19-1.4-1.31-.53a6.67,6.67,0,0,1-1.52-.88l-1.13-.87-1.31.54-1.57.63-.87-1.5,1.34-1,1.1-.86L34,13.28c0-.38-.07-.67-.07-.92a9,9,0,0,1,.07-.9l.17-1.4L33,9.2l-1.34-1,.87-1.5,1.57.63,1.28.52L36.52,7a7.57,7.57,0,0,1,1.54-.9l1.31-.53.2-1.4.25-1.67h1.72l.23,1.67.2,1.4,1.31.53A6.67,6.67,0,0,1,44.8,7l1.13.86,1.31-.53,1.57-.63.87,1.5-1.33,1-1.1.86.18,1.4Zm-6.73-4a4.95,4.95,0,1,0,4.94,4.94A4.94,4.94,0,0,0,40.69,7.42Zm0,7.42a2.48,2.48,0,1,1,2.47-2.48A2.49,2.49,0,0,1,40.69,14.84Z",
    transform: "translate(0 0)",
    fill: "#ed7333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.67,54.05c1.07-.08.55-.48,1.34-1.27,1.39-1.43,3.16-2.86,3.37-4.24L28.47,47l-.63,3.52c0,.56,0,1.61,0,2-.1.87-.59.58-.13,1.52Z",
    transform: "translate(0 0)",
    fill: "#ed7333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.13,12.55C-.12,13.92.07,37.5.07,40.1c0,1.92-.32,7.38.42,8.84,1.29,2.54,4.9,1.87,7.34,1.87,2.29,0,17.23.15,18.19-.08.3-1.37-.11-2.7.6-4.12.62-1.23.26-.71.39-1.93.08-.69,4-9.68,4.78-11.43a6.15,6.15,0,0,0,.81-3.74c0-.42,0-1.11,0-2A17.22,17.22,0,0,1,25.3,20H5.05a1.58,1.58,0,0,1,0-3.15H24.1a17.3,17.3,0,0,1-.6-4.52,17,17,0,0,1,.21-2.69H6.51C4,9.68.73,9.27.14,12.55ZM5.05,22.89h20.8a1.58,1.58,0,0,1,0,3.16H5.05a1.58,1.58,0,1,1,0-3.16Zm0,6.16h20.8a1.58,1.58,0,0,1,0,3.16H5.05a1.58,1.58,0,1,1,0-3.16ZM5,38.81h8.47A1.55,1.55,0,0,1,15,40.36v2.51a1.56,1.56,0,0,1-1.56,1.56H5a1.56,1.56,0,0,1-1.55-1.56V40.36A1.55,1.55,0,0,1,5,38.81Z",
    transform: "translate(0 0)",
    fill: "#ed7333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3,31.91c-.39.55-5.55,12.55-5.5,13.48l4.54,1.86,4.83-10.84C38.8,35,40,32.05,41,29.55h-.35a17.4,17.4,0,0,1-5.08-.76l-1.3,3.12Z",
    transform: "translate(0 0)",
    fill: "#ed7333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.14,29.38C42,32.47,39.28,37.1,39.45,38.7c.2.62.7.76,1.41-.91l2.41-5.72c.53-1.21,1-2.14,1.31-3q-.7.16-1.44.27Z",
    transform: "translate(0 0)",
    fill: "#ed7333",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgI4);
export default __webpack_public_path__ + "static/media/I4.715cb268a9c8584bcb71bd67d5742606.svg";
export { ForwardRef as ReactComponent };